function PlanGroupChannelCell(props) {
    return <>{props.value?.map((obj) => obj.label).join(",") ?? "-"}</>;
}

export default PlanGroupChannelCell;
